import { cn } from '../../lib/cn';
import { Tone, TONE_DOT_CLASS, TONE_HALO_CLASS } from './tones';

export interface StatusDotProps {
  tone: Tone;
  size?: number;
  /** Soft halo ring behind the dot. */
  halo?: boolean;
  className?: string;
}

/** The smallest status primitive — a colored dot, nothing else. Every pill composes this. */
export function StatusDot({ tone, size = 8, halo = false, className }: StatusDotProps) {
  return (
    <span
      className={cn('inline-block shrink-0 rounded-full', TONE_DOT_CLASS[tone], halo && TONE_HALO_CLASS[tone], className)}
      style={{ width: size, height: size }}
    />
  );
}
